export enum StatusEnum {
  Inactive,
  Active,
}
